export default __webpack_public_path__ + "static/media/loader.8e591aa9.gif";